const dictionary = [
  { word: "Algorithm", hint: "Step-by-step procedure to solve a problem" },
  {
    word: "Variable",
    hint: "A storage location identified by a memory address",
  },
  { word: "Database", hint: "Organized collection of data" },
  { word: "JavaScript", hint: "High-level programming language" },
  { word: "Framework", hint: "Reusable set of libraries or tools" },
  { word: "Encryption", hint: "Process of converting data into a code" },
  { word: "API", hint: "Application Programming Interface" },
  { word: "Git", hint: "Version control system for tracking changes" },
  { word: "Responsive", hint: "Design that adapts to different devices" },
  { word: "Scalability", hint: "Ability of a system to handle growth" },
  {
    word: "Container",
    hint: "Lightweight, executable package that includes everything needed to run a piece of software",
  },
  { word: "DevOps", hint: "Collaboration between development and operations" },
  {
    word: "Blockchain",
    hint: "Distributed and decentralized ledger technology",
  },
  {
    word: "Microservices",
    hint: "Architectural style that structures an application as a collection of small, independent services",
  },
  { word: "API Gateway", hint: "Server that acts as an API front-end" },
  {
    word: "Serverless",
    hint: "Architecture where server management is handled by a cloud provider",
  },
  { word: "JavaScript", hint: "Programming language for web development" },
  {
    word: "Node.js",
    hint: "JavaScript runtime built on Chrome's V8 JavaScript engine",
  },
  { word: "React", hint: "JavaScript library for building user interfaces" },
  { word: "Python", hint: "High-level programming language" },
  {
    word: "Machine Learning",
    hint: "Subset of artificial intelligence that focuses on the development of algorithms",
  },
  {
    word: "RESTful",
    hint: "Representational State Transfer architectural style",
  },
  { word: "GraphQL", hint: "Query language for APIs" },
  {
    word: "Continuous Integration",
    hint: "Software development practice where code changes are automatically built, tested, and deployed",
  },
  {
    word: "Containerization",
    hint: "Encapsulation of an application and its dependencies into a container",
  },
  { word: "Kubernetes", hint: "Open-source container orchestration platform" },
  {
    word: "Lambda Function",
    hint: "Serverless compute service that runs code in response to events",
  },
  {
    word: "Blockchain",
    hint: "Distributed and decentralized ledger technology",
  },
  {
    word: "Decentralized",
    hint: "Distributed system where no single entity has control",
  },
  {
    word: "Smart Contract",
    hint: "Self-executing contract with the terms of the agreement directly written into code",
  },
  {
    word: "Web3",
    hint: "Next evolution of the internet focused on decentralization",
  },
  {
    word: "Distributed Ledger",
    hint: "Database spread across multiple sites or nodes",
  },
  {
    word: "Open Source",
    hint: "Software with a license that allows anyone to view, use, modify, and distribute the code",
  },
  {
    word: "Pull Request",
    hint: "Proposal to include changes in the main codebase",
  },
  { word: "Fork", hint: "Personal copy of someone else's project" },
  {
    word: "Bug",
    hint: "Error or flaw in software that produces incorrect or unexpected results",
  },
  { word: "Debugging", hint: "Process of finding and fixing bugs in software" },
  { word: "Lambda", hint: "Anonymous function in programming" },
  {
    word: "Repository",
    hint: "Central location in which data is stored and managed",
  },
  {
    word: "Responsive Design",
    hint: "Approach to web design that makes web pages render well on a variety of devices and window or screen sizes",
  },
  {
    word: "Dependency Injection",
    hint: "Design pattern in which a class receives its dependencies from external sources",
  },
  {
    word: "Syntax",
    hint: "Set of rules for writing programs in a programming language",
  },
  { word: "Framework", hint: "Reusable set of libraries or tools" },
  { word: "HTTP", hint: "Hypertext Transfer Protocol" },
  {
    word: "Web Assembly",
    hint: "Binary instruction format for a stack-based virtual machine",
  },
  { word: "Backend", hint: "Server-side of an application" },
  { word: "Frontend", hint: "Client-side of an application" },
  {
    word: "Code Review",
    hint: "Systematic examination of computer source code",
  },
  { word: "NPM", hint: "Node Package Manager" },
  { word: "Webpack", hint: "Open-source JavaScript module bundler" },
  {
    word: "Server",
    hint: "Computer or system that manages network resources and provides services to other computers in the network",
  },
  {
    word: "Continuous Deployment",
    hint: "Practice of automatically deploying every code change to production",
  },
  { word: "Azure", hint: "Cloud computing service created by Microsoft" },
  { word: "AWS", hint: "Amazon Web Services" },
  { word: "Google Cloud", hint: "Cloud computing services by Google" },
  {
    word: "API Key",
    hint: "Code passed in by computer programs calling an API",
  },
  {
    word: "REST API",
    hint: "Application Programming Interface that conforms to the principles of REST",
  },
  {
    word: "Docker",
    hint: "Platform for developing, shipping, and running applications in containers",
  },
  {
    word: "Micro Frontends",
    hint: "Architectural style where a front-end is decomposed into individual, semi-independent microapps",
  },
  { word: "GraphQL", hint: "Query language for APIs" },
  {
    word: "Unit Testing",
    hint: "Testing individual units or components of a software",
  },
  {
    word: "Linting",
    hint: "Static code analysis to find problems and ensure consistency in code style",
  },
  {
    word: "Continuous Integration",
    hint: "Software development practice where code changes are automatically built, tested, and deployed",
  },
  {
    word: "WebSockets",
    hint: "Communication protocol that provides full-duplex communication channels over a single TCP connection",
  },
  {
    word: "Virtual DOM",
    hint: "Programming concept where an ideal, or 'virtual', representation of a UI is kept in memory and synced with the 'real' DOM by a library such as React",
  },
  {
    word: "Full Stack",
    hint: "Development involving both front-end and back-end technologies",
  },
  {
    word: "JWT",
    hint: "JSON Web Token - a compact, URL-safe means of representing claims to be transferred between two parties",
  },
  { word: "OAuth", hint: "Open standard for access delegation" },
  {
    word: "Agile",
    hint: "Project management and product development approach",
  },
  {
    word: "Kanban",
    hint: "Method for managing knowledge work with an emphasis on just-in-time delivery while not overloading the team members",
  },
  { word: "Linux", hint: "Open-source, Unix-like operating system kernel" },
  {
    word: "Unix",
    hint: "Operating system family that includes Linux and macOS",
  },
  {
    word: "Regex",
    hint: "Sequence of characters that defines a search pattern",
  },
  { word: "Lambda Expression", hint: "Anonymous function in programming" },
  {
    word: "Dependency Injection",
    hint: "Design pattern in which a class receives its dependencies from external sources",
  },
  {
    word: "Web Socket",
    hint: "Communication protocol providing full-duplex communication channels over a single TCP connection",
  },
  { word: "API Gateway", hint: "Server that acts as an API front-end" },
  {
    word: "Serverless",
    hint: "Architecture where server management is handled by a cloud provider",
  },
  {
    word: "Docker Compose",
    hint: "Tool for defining and running multi-container Docker applications",
  },
  {
    word: "Agile",
    hint: "Project management and product development approach",
  },
  {
    word: "Scrum",
    hint: "Framework within which people can address complex adaptive problems",
  },
  {
    word: "Kanban",
    hint: "Method for managing knowledge work with an emphasis on just-in-time delivery while not overloading the team members",
  },
  {
    word: "Pair Programming",
    hint: "Programming technique where two programmers work together at one workstation",
  },
  {
    word: "Code Review",
    hint: "Systematic examination of computer source code",
  },
  { word: "Git Branch", hint: "Pointer to a snapshot of your changes" },
  {
    word: "Pull Request",
    hint: "Proposal to include changes in the main codebase",
  },
  {
    word: "Code Coverage",
    hint: "Percentage of code that is covered by automated tests",
  },
  {
    word: "Continuous Deployment",
    hint: "Practice of automatically deploying every code change to production",
  },
  {
    word: "Infrastructure as Code",
    hint: "Managing and provisioning computing infrastructure through machine-readable script files",
  },
  { word: "GraphQL", hint: "Query language for APIs" },
  {
    word: "Database Migration",
    hint: "Process of transferring data between storage types or formats",
  },
  {
    word: "Progressive Web App",
    hint: "Web application that uses modern web capabilities to deliver an app-like experience",
  },
  {
    word: "WebAssembly",
    hint: "Binary instruction format for a stack-based virtual machine",
  },
  {
    word: "Single Page Application",
    hint: "Web application or website that interacts with the user by dynamically rewriting the current page",
  },
  {
    word: "CORS",
    hint: "Cross-Origin Resource Sharing - a security feature implemented by web browsers",
  },
  {
    word: "JWT",
    hint: "JSON Web Token - a compact, URL-safe means of representing claims to be transferred between two parties",
  },
  { word: "OAuth", hint: "Open standard for access delegation" },
  { word: "GraphQL", hint: "Query language for APIs" },
  {
    word: "REST API",
    hint: "Application Programming Interface that conforms to the principles of REST",
  },
  {
    word: "WebSockets",
    hint: "Communication protocol that provides full-duplex communication channels over a single TCP connection",
  },
  {
    word: "Virtual DOM",
    hint: "Programming concept where an ideal, or 'virtual', representation of a UI is kept in memory and synced with the 'real' DOM by a library such as React",
  },
  {
    word: "Full Stack",
    hint: "Development involving both front-end and back-end technologies",
  },
  {
    word: "JWT",
    hint: "JSON Web Token - a compact, URL-safe means of representing claims to be transferred between two parties",
  },
  { word: "OAuth", hint: "Open standard for access delegation" },
  {
    word: "Agile",
    hint: "Project management and product development approach",
  },
  {
    word: "Kanban",
    hint: "Method for managing knowledge work with an emphasis on just-in-time delivery while not overloading the team members",
  },
  { word: "Linux", hint: "Open-source, Unix-like operating system kernel" },
  {
    word: "Unix",
    hint: "Operating system family that includes Linux and macOS",
  },
  {
    word: "Regex",
    hint: "Sequence of characters that defines a search pattern",
  },
  { word: "Lambda Expression", hint: "Anonymous function in programming" },
  {
    word: "Dependency Injection",
    hint: "Design pattern in which a class receives its dependencies from external sources",
  },
  {
    word: "Web Socket",
    hint: "Communication protocol providing full-duplex communication channels over a single TCP connection",
  },
  { word: "API Gateway", hint: "Server that acts as an API front-end" },
  {
    word: "Serverless",
    hint: "Architecture where server management is handled by a cloud provider",
  },
  {
    word: "Docker Compose",
    hint: "Tool for defining and running multi-container Docker applications",
  },
  {
    word: "Agile",
    hint: "Project management and product development approach",
  },
  {
    word: "Scrum",
    hint: "Framework within which people can address complex adaptive problems",
  },
  {
    word: "Kanban",
    hint: "Method for managing knowledge work with an emphasis on just-in-time delivery while not overloading the team members",
  },
  {
    word: "Pair Programming",
    hint: "Programming technique where two programmers work together at one workstation",
  },
  {
    word: "Code Review",
    hint: "Systematic examination of computer source code",
  },
  { word: "Git Branch", hint: "Pointer to a snapshot of your changes" },
  {
    word: "Pull Request",
    hint: "Proposal to include changes in the main codebase",
  },
  {
    word: "Code Coverage",
    hint: "Percentage of code that is covered by automated tests",
  },
  {
    word: "Continuous Deployment",
    hint: "Practice of automatically deploying every code change to production",
  },
  {
    word: "Infrastructure as Code",
    hint: "Managing and provisioning computing infrastructure through machine-readable script files",
  },
  { word: "GraphQL", hint: "Query language for APIs" },
  {
    word: "Database Migration",
    hint: "Process of transferring data between storage types or formats",
  },
  {
    word: "Progressive Web App",
    hint: "Web application that uses modern web capabilities to deliver an app-like experience",
  },
  {
    word: "WebAssembly",
    hint: "Binary instruction format for a stack-based virtual machine",
  },
  {
    word: "Single Page Application",
    hint: "Web application or website that interacts with the user by dynamically rewriting the current page",
  },
  {
    word: "CORS",
    hint: "Cross-Origin Resource Sharing - a security feature implemented by web browsers",
  },
];

export default dictionary;
